/**
 * Pobiera listę produktów abonamentowych z zaległą płatnością
 */
app.service('overdueSubscriptionProducts', function (modal, loading, ajaxErrorHandler, accountSubscriptionPayments, lazyLoad, front, account) {

	let $self;

	function init() {
		if (!account.isFrontUserLogged()) {
			return;
		}

		setElements();
		setEvents();
		loadOverdueSubscriptionProducts();
	}

	function setElements() {
		$self = $('#account-overdue-subscriptions');
	}

	function setEvents() {
		$('body')
			.on('click', '.js-init-recurring-payment', function () {
				UA.interaction('KME', 'Abonament', 'Aktywuj ochrone sprzetu')
				const orderNumber = $(this).attr('data-order-number');
				accountSubscriptionPayments.initRecurringPayment(orderNumber);
			})
			.on('click', '.js-subscription-service-payment, .js-subscription-warranty-payment', function () {
				const recurringPaymentId = $(this).data('recurring-payment-id');
				const singlePaymentId = $(this).data('single-payment-id');
				accountSubscriptionPayments.paySubscriptionFee(recurringPaymentId, singlePaymentId);
			});
	}

	function loadOverdueSubscriptionProducts() {
		fetchOverdueSubscriptionProducts()
			.then(subscriptionProductsHtml => {
				if (subscriptionProductsHtml && subscriptionProductsHtml.trim().length > 0) {
					$self.html(subscriptionProductsHtml);
					lazyLoad.update();
				}
			})
			.fail((jqXHR, textStatus, errorThrown) => {
				const handleError = ajaxErrorHandler.createFailHandler('overdueSubscriptionProducts.loadOverdueSubscriptionProducts');
				handleError(jqXHR, textStatus, errorThrown);
				$self.html('<div class="error-message">Wystąpił błąd podczas ładowania listy subskrypcji. Odśwież stronę lub spróbuj ponownie później.</div>');
			});
	}

	function fetchOverdueSubscriptionProducts() {
		const data = {
			subscriptionOrderTypeOnly: front.page() !== 'account-main-page'
		};

		return $.ajax({
			method: 'GET',
			url: '/customer-subscription-products-summary.ltr',
			data: data
		});
	}

	return {
		init
	};
});
